<template>
    <div class="home">
        <img class='pc-img' alt="" src="../assets/img-pc.jpg" />
        <img class='h5-img' alt="" src="../assets/img-h5.jpg" />
        <div class='download-wrapper' @click="handleDownload">
        </div>
        <div class='code'>
        <a  href="https://beian.miit.gov.cn/?spm=a2cmq.17630005.0.0.45c079fekYxs2z#/Integrated/index">备案号码：沪ICP备20011658号-1</a>
        </div>
    </div>
    
</template>

<script>
// @ is an alias to /src


export default {
    name: "Home",
    components: {
        
    },

    methods: {
        handleDownload() {
            let u = window.navigator.userAgent;
            console.log(u);
            let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   // android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);   // ios终端
            let urls = {
                android: 'https://files.qianyuesport.com/qy-app-2.1.1.apk',
                ios: 'https://apps.apple.com/cn/app/%E4%BA%91%E6%95%99%E7%BB%83/id1525629837',
            };
            
            if (isAndroid) {
                window.location.href = urls.android;
            } else if (isiOS) {
                window.location.href = urls.ios;
            }
        }
    }
};
</script>

<style lang="less" scoped>
    .pc-img,
    .h5-img {
        width: 100%;
    }
    .code{
        text-align: center;
        height: 30px;
        line-height: 30px;
        margin-top: 8px;
    }

    .download-wrapper {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 74px;
        background: url('../assets/img-download.png') no-repeat center center / cover;
    }

    @media screen and (max-width: 750px) {
        .pc-img {
            display: none;
        }
    }

    @media screen and (min-width: 760px) {
        .h5-img {
            display: none;
        }

        .download-wrapper {
            display: none;
        }
    }
</style>
